import {
  CompanyEmployeeAction,
  ECompanyEmployeeActions,
  GetAllCompanyEmployes,
} from '../actions/companyEmployee.action';
import {
  ICompanyEmployeeState,
  initialCompanyEmployeeState,
} from '../state/companyEmployee.state';
import { act } from '@ngrx/effects';

export function companyEmployeeReducers(
  state = initialCompanyEmployeeState,
  action: CompanyEmployeeAction
): ICompanyEmployeeState {
  switch (action.type) {
    case ECompanyEmployeeActions.GetAllCompanyEmployes: {
      return {
        ...state,
        getAllCompanyEmployesInProgress: true,
      };
    }
    case ECompanyEmployeeActions.GetAllCompanyEmployesSuccess: {
      // console.log(action.payload)
      return {
        ...state,
        getAllCompanyEmployesSuccess: action.payload,
        getAllCompanyEmployesError: null,
        getAllCompanyEmployesInProgress: false,
      };
    }
    case ECompanyEmployeeActions.GetAllCompanyEmployesError: {
      return {
        ...state,
        getAllCompanyEmployesError: action.payload,
        getAllCompanyEmployesSuccess: null,
        getAllCompanyEmployesInProgress: false,
      };
    }
    case ECompanyEmployeeActions.GetAllCompanyEmployesReset: {
      return {
        ...state,
        getAllCompanyEmployesError: null,
        getAllCompanyEmployesSuccess: null,
        getAllCompanyEmployesInProgress: false,
      };
    }
    case ECompanyEmployeeActions.GetAllCompanyEmployesByRoleSuccess: {
      // console.log(action.payload)
      return {
        ...state,
        getAllCompanyEmployesByRolesSuccess: action.payload,
        getAllCompanyEmployesByRolesError: null,
      };
    }
    case ECompanyEmployeeActions.GetAllCompanyEmployesByRoleError: {
      return {
        ...state,
        getAllCompanyEmployesByRolesError: action.payload,
        getAllCompanyEmployesByRolesSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetAddCompanyEmployeeSuccess: {
      return {
        ...state,
        getAddCompanyEmployeeSuccess: action.payload,
        getAddCompanyEmployeeError: null,
      };
    }
    case ECompanyEmployeeActions.GetAddCompanyEmployeeError: {
      return {
        ...state,
        getAddCompanyEmployeeError: action.payload,
        getAddCompanyEmployeeSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetEditCompanyEmployeeSuccess: {
      return {
        ...state,
        getEditCompanyEmployeeSuccess: action.payload,
        getEditCompanyEmployeeError: null,
      };
    }
    case ECompanyEmployeeActions.GetEditCompanyEmployeeError: {
      return {
        ...state,
        getEditCompanyEmployeeError: action.payload,
        getEditCompanyEmployeeSuccess: null,
      };
    }
    case ECompanyEmployeeActions.LoginCompanyEmployeeSuccess: {
      return {
        ...state,
        getLoginCompanyEmployeeSuccess: action.payload,
        getLoginCompanyEmployeeError: null,
      };
    }
    case ECompanyEmployeeActions.LoginCompanyEmployeeError: {
      return {
        ...state,
        getLoginCompanyEmployeeError: action.payload,
        getLoginCompanyEmployeeSuccess: null,
      };
    }
    case ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswdSuccess: {
      return {
        ...state,
        sendLinkComapanyEmployeeFrgtPswdSuccess: action.payload,
        sendLinkComapanyEmployeeFrgtPswdError: null,
      };
    }
    case ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswdError: {
      return {
        ...state,
        sendLinkComapanyEmployeeFrgtPswdSuccess: null,
        sendLinkComapanyEmployeeFrgtPswdError: action.payload,
      };
    }
    case ECompanyEmployeeActions.CompanyEmployeeResetPasswordSuccess: {
      return {
        ...state,
        getComapanyEmployeeFrgtresetPasswordSuccess: action.payload,
        getComapanyEmployeeFrgtresetPasswordError: null,
      };
    }
    case ECompanyEmployeeActions.CompanyEmployeeResetPasswordError: {
      return {
        ...state,
        getComapanyEmployeeFrgtresetPasswordError: action.payload,
        getComapanyEmployeeFrgtresetPasswordSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetEmployeesToAddMasterUserSuccess: {
      return {
        ...state,
        getEmployeesToAddMasterUserSuccess: action.payload,
        setCompanyEmployeesErrorMsg: null,
      };
    }
    case ECompanyEmployeeActions.SetCompanyEmployeesErrorMsg: {
      return {
        ...state,
        setCompanyEmployeesErrorMsg: action.payload,
        getEmployeesToAddMasterUserSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetEmployeesToAddSubUserSuccess: {
      return {
        ...state,
        getEmployeesToAddSubUserSuccess: action.payload,
        getEmployeesToAddSubUserError: null,
      };
    }
    case ECompanyEmployeeActions.GetEmployeesToAddSubUserError: {
      return {
        ...state,
        getEmployeesToAddSubUserError: action.payload,
        getEmployeesToAddSubUserSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetRemoveCmpyUsersSuccess: {
      return {
        ...state,
        getRemoveCmpyUsersSuccess: action.payload,
        getRemoveCmpyUsersError: null,
      };
    }
    case ECompanyEmployeeActions.GetRemoveCmpyUsersError: {
      return {
        ...state,
        getRemoveCmpyUsersError: action.payload,
        getRemoveCmpyUsersSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetRemoveUserRolesSuccess: {
      // console.log(action.payload)
      return {
        ...state,
        getRemoveUserRolesSuccess: action.payload,
        getRemoveUserRolesError: null,
      };
    }
    case ECompanyEmployeeActions.GetRemoveUserRolesError: {
      return {
        ...state,
        getRemoveUserRolesError: action.payload,
        getRemoveUserRolesSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetUpdatedRoleUserSuccess: {
      // console.log(action.payload)
      return {
        ...state,
        getRoleUserSuccess: action.payload,
        getRoleUserError: null,
      };
    }
    case ECompanyEmployeeActions.GetUpdatedRoleUserError: {
      return {
        ...state,
        getRoleUserError: action.payload,
        getRoleUserSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetAllSalesControllerUsersSuccess: {
      return {
        ...state,
        getAllSalesControllerUsersSuccess: action.payload,
        getAllSalesControllerUsersError: null,
      };
    }
    case ECompanyEmployeeActions.GetAllSalesControllerUsersError: {
      return {
        ...state,
        getAllSalesControllerUsersError: action.payload,
        getAllSalesControllerUsersSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetAllWarehouseControllerUsersSuccess: {
      return {
        ...state,
        getAllWarehouseControllerUsersSuccess: action.payload,
        getAllWarehouseControllerUsersError: null,
      };
    }
    case ECompanyEmployeeActions.GetAllWarehouseControllerUsersError: {
      return {
        ...state,
        getAllWarehouseControllerUsersError: action.payload,
        getAllWarehouseControllerUsersSuccess: null,
      };
    }
    case ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsersSuccess: {
      return {
        ...state,
        getAllwarehouseandproductionUsersSuccess: action.payload,
        getAllwarehouseandproductionUsersError: null,
      };
    }
    case ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsersError: {
      return {
        ...state,
        getAllwarehouseandproductionUsersError: action.payload,
        getAllwarehouseandproductionUsersSuccess: null,
      };
    }
    default: {
      return state;
    }
  }
}
